import { message } from "antd";
import { ReactNode } from "react";
import { Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";

export interface ClosableMessageOptions {
  /** 消息内容 */
  content: ReactNode;
  /** 按钮文本，默认为"去加购" */
  buttonText?: ReactNode;
  /** 按钮点击回调 */
  onButtonClick?: () => void;
  /** 关闭按钮文本，默认为"关闭" */
  closeText?: ReactNode;
  /** 消息持续时间，0 表示不自动关闭 */
  duration?: number;
}

/**
 * 显示带关闭按钮的全局 message hook
 */
export const useClosableMessage = () => {
  const navigate = useNavigate();

  const showClosableMessage = (options: ClosableMessageOptions): (() => void) => {
    const {
      content,
      buttonText = <Trans>Go to buy</Trans>,
      onButtonClick: _onButtonClick,
      closeText: _closeText = "关闭",
      duration = 0,
    } = options;
    const closeMessage = message.error({
      content: (
        <div className="flex justify-center items-center">
          <Trans>{content}</Trans>
          <a
            className="ml-2 cursor-pointer underline"
            onClick={() => {
              closeMessage();
              navigate("/pricing#package");
            }}
          >
            {buttonText}
          </a>
        </div>
      ),
      duration,
    });

    return closeMessage;
  };

  return { showClosableMessage };
};
